// window.MI_CONFIG = { shopCurrency: 'GTQ', sectionPrefix: 'amp3d' }; // reservado, no requerido por esta seccion
// window.CHECKOUT_APP = { provider: 'releasit-cod-form-builder', mount: '.amp3d-cod' }; // la app Releasit se auto-monta en su bloque, no llamar manualmente
(function(){
  'use strict';
  document.querySelectorAll('.amp3d-section').forEach(initSection);

  function initSection(root){
    initGallery(root);
    initMiniSlider(root);
    initAccordionLazy(root);
    initGifLazy(root);
  }

  function initGallery(root){
    var track = root.querySelector('.amp3d-gallery-track');
    if(!track) return;
    var dots = root.querySelectorAll('.amp3d-dot');
    var slides = track.querySelectorAll('.amp3d-gallery-slide');
    if(!slides.length) return;
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){
          var i = Array.prototype.indexOf.call(slides, e.target);
          dots.forEach(function(d,di){ d.classList.toggle('is-active', di===i); });
        }
      });
    }, { root: track, threshold: 0.6 });
    slides.forEach(function(s){ io.observe(s); });
    dots.forEach(function(d,i){
      d.addEventListener('click', function(){ slides[i].scrollIntoView({ behavior:'smooth', inline:'center' }); });
    });
  }

  function initMiniSlider(root){
    var wrap = root.querySelector('.amp3d-mini-slider');
    if(!wrap) return;
    var slides = wrap.querySelectorAll('.amp3d-mini-slide');
    var dots = wrap.querySelectorAll('.amp3d-mini-dot');
    if(!slides.length) return;
    var idx = 0, timer = null;
    function show(i){
      idx = i % slides.length;
      slides.forEach(function(s,si){ s.classList.toggle('is-active', si===idx); });
      dots.forEach(function(d,di){ d.classList.toggle('is-active', di===idx); });
    }
    function next(){ show(idx+1); }
    function start(){ stop(); timer = setInterval(next, 5000); }
    function stop(){ if(timer) clearInterval(timer); }
    dots.forEach(function(d,i){ d.addEventListener('click', function(){ show(i); start(); }); });
    show(0);
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ e.isIntersecting ? start() : stop(); });
    }, { threshold: 0.3 });
    io.observe(wrap);
  }

  function initAccordionLazy(root){
    var acc = root.querySelector('.amp3d-accordion');
    if(!acc) return;
    var io = new IntersectionObserver(function(entries, obs){
      entries.forEach(function(e){
        if(!e.isIntersecting) return;
        bindAccordion(acc);
        obs.disconnect();
      });
    }, { threshold: 0.1 });
    io.observe(acc);
  }

  function bindAccordion(acc){
    var triggers = acc.querySelectorAll('.amp3d-acc-trigger');
    triggers.forEach(function(btn){
      btn.addEventListener('click', function(){
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        var open = btn.getAttribute('aria-expanded') === 'true';
        triggers.forEach(function(b){
          b.setAttribute('aria-expanded','false');
          var p = document.getElementById(b.getAttribute('aria-controls'));
          if(p) p.style.maxHeight = null;
        });
        if(!open && panel){
          btn.setAttribute('aria-expanded','true');
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      });
    });
  }

  function initGifLazy(root){
    var gifs = root.querySelectorAll('img[data-amp3d-gif]');
    if(!gifs.length) return;
    var io = new IntersectionObserver(function(entries, obs){
      entries.forEach(function(e){
        if(!e.isIntersecting) return;
        var img = e.target;
        var src = img.getAttribute('data-src');
        if(src){ img.src = src; img.removeAttribute('data-src'); }
        obs.unobserve(img);
      });
    }, { rootMargin: '200px 0px' });
    gifs.forEach(function(g){ io.observe(g); });
  }
})();
